(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-cart-drawer]')
    if (!root || root.dataset.initialized === 'true') return
    root.dataset.initialized = 'true'
    const drawer = root.querySelector('.cart-drawer')
    const content = root.querySelector('[data-cart-content]')
    const threshold = Number(root.dataset.threshold)
    const protectionId = Number(root.dataset.protectionId)
    const protectionPrice = Number(root.dataset.protectionPrice)
    const formatter = new Intl.NumberFormat(root.dataset.locale, { style: 'currency', currency: root.dataset.currency, maximumFractionDigits: 0 })
    const escapeHtml = value => String(value ?? '').replace(/[&<>'"]/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character])
    const money = value => formatter.format(Number(value) / 100)
    const giftDeadline = Date.now() + 499000
    const updateGiftCountdown = () => { const seconds = Math.max(0, Math.ceil((giftDeadline - Date.now()) / 1000)); const value = `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`; root.querySelectorAll('[data-gift-countdown]').forEach(timer => { timer.textContent = value }) }
    setInterval(updateGiftCountdown, 1000)
    queueMicrotask(updateGiftCountdown)
    const close = () => { root.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.classList.remove('cart-drawer-open') }
    const emptyMarkup = () => `<div class="cart-drawer__empty"><svg viewBox="0 0 150 130" aria-hidden="true"><path d="M25 30h18l12 58h58l8-42H48M59 106a10 10 0 1 0 0 .1M104 106a10 10 0 1 0 0 .1"></path><circle cx="98" cy="42" r="25"></circle><path d="m87 31 22 22m0-22L87 53"></path></svg><p>${escapeHtml(root.dataset.emptyText)}</p><a href="${escapeHtml(root.dataset.shopUrl)}">${escapeHtml(root.dataset.shopText)}</a></div>`
    const itemMarkup = item => { const image = item.featured_image?.url || item.image || ''; const imageUrl = image ? `${image}${image.includes('?') ? '&' : '?'}width=300` : ''; const variant = item.product_has_only_default_variant ? '' : `<p>${escapeHtml(item.variant_title || '')}</p>`; const oldPrice = item.original_price > item.final_price ? `<s>${money(item.original_price)}</s>` : ''; return `<article class="drawer-item"><a class="drawer-item__image" href="${escapeHtml(item.url)}">${imageUrl ? `<img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(item.product_title)}">` : ''}</a><div class="drawer-item__info"><a href="${escapeHtml(item.url)}"><h3>${escapeHtml(item.product_title)}</h3></a><div class="drawer-item__prices">${oldPrice}<strong>${money(item.final_price)}</strong></div>${variant}<div class="drawer-item__bottom"><div class="drawer-quantity"><button type="button" data-cart-quantity="${escapeHtml(item.key)}" data-quantity="${item.quantity - 1}">−</button><span>${item.quantity}</span><button type="button" data-cart-quantity="${escapeHtml(item.key)}" data-quantity="${item.quantity + 1}">+</button></div><button class="drawer-remove" type="button" data-cart-quantity="${escapeHtml(item.key)}" data-quantity="0">${escapeHtml(root.dataset.removeText)}</button></div></div></article>` }
    const giftMarkup = () => `<div class="gift-reservation" data-gift-reservation><span class="gift-reservation__icon" aria-hidden="true"><svg viewBox="0 0 32 32"><path d="M5 13h22v15H5zM3 9h26v6H3zM16 9v19M16 9c-5 0-8-1.3-8-4 0-1.7 1.3-3 3-3 3.2 0 5 4 5 7Zm0 0c5 0 8-1.3 8-4 0-1.7-1.3-3-3-3-3.2 0-5 4-5 7Z"/></svg></span><strong class="gift-reservation__title">REGALO</strong><span class="gift-reservation__timer">Expira: <b data-gift-countdown>8:19</b></span><small class="gift-reservation__text">¡Casi listo! Completa tu pedido y llévate un <b>regalo gratis</b> con esta compra.</small></div>`
    const protectionMarkup = checked => root.dataset.protectionEnabled === 'true' ? `<label class="shipping-protection"><input type="checkbox" data-shipping-protection${checked ? ' checked' : ''}><span class="shipping-protection__check" aria-hidden="true">✓</span><span class="shipping-protection__lock" aria-hidden="true"><svg viewBox="0 0 24 28"><path d="M6 11V8a6 6 0 0 1 12 0v3"/><rect x="3" y="11" width="18" height="14" rx="3"/><circle cx="12" cy="18" r="1.5"/></svg></span><span class="shipping-protection__copy"><strong>${escapeHtml(root.dataset.protectionTitle)}</strong><small>${escapeHtml(root.dataset.protectionText)}</small></span><strong class="shipping-protection__price">${money(protectionPrice)}</strong></label>` : ''
    const render = cart => { const protectionLine = cart.items.find(item => Number(item.variant_id) === protectionId); const visibleItems = cart.items.filter(item => Number(item.variant_id) !== protectionId); const visibleCount = visibleItems.reduce((sum, item) => sum + item.quantity, 0); document.querySelectorAll('.header-icon--cart sup').forEach(count => { count.textContent = visibleCount }); if (!visibleCount) { content.innerHTML = emptyMarkup(); return } const payments = root.querySelector('[data-cart-payments]').innerHTML; const remaining = Math.max(threshold - cart.total_price, 0); const progress = Math.min(cart.total_price * 100 / threshold, 100); const baseText = escapeHtml(root.dataset.remainingText).replace(':', ''); const amountText = `<strong>${money(remaining)}</strong>`; const progressText = remaining > 0 ? (baseText.includes('MÁS') ? baseText.replace('MÁS', `${amountText} MÁS`) : `${baseText} ${amountText}`) : escapeHtml(root.dataset.freeText); const discount = cart.total_discount > 0 ? `<div><span>${escapeHtml(root.dataset.discountsText)}</span><strong class="drawer-discount">−${money(cart.total_discount)}</strong></div>` : ''; content.innerHTML = `<div class="cart-drawer__progress"><p>${progressText}</p><div><span style="width:${progress}%"></span></div></div><div class="cart-drawer__items">${visibleItems.map(itemMarkup).join('')}</div><form class="cart-drawer__summary" action="${escapeHtml(root.dataset.cartPageUrl)}" method="post">${giftMarkup()}${protectionMarkup(Boolean(protectionLine))}<div><span>${escapeHtml(root.dataset.subtotalText)}</span><strong>${money(cart.items_subtotal_price)}</strong></div>${discount}<button type="submit" name="checkout">${escapeHtml(root.dataset.checkoutText)} · ${money(cart.total_price)}</button><div class="cart-drawer__payments">${payments}</div></form>` }
    const refresh = async () => { const response = await fetch(root.dataset.cartUrl, { headers: { Accept: 'application/json' } }); if (response.ok) render(await response.json()) }
    const open = async () => { root.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.classList.add('cart-drawer-open'); root.querySelector('.cart-drawer__close')?.focus(); await refresh() }
    document.addEventListener('click', async event => { const cartLink = event.target.closest('.header-icon--cart'); if (cartLink) { event.preventDefault(); open(); return } if (event.target.closest('[data-cart-close]')) { close(); return } const quantity = event.target.closest('[data-cart-quantity]'); if (!quantity) return; quantity.disabled = true; const response = await fetch(root.dataset.changeUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: quantity.dataset.cartQuantity, quantity: Number(quantity.dataset.quantity) }) }); if (response.ok) render(await response.json()) })
    document.addEventListener('change', async event => { const toggle = event.target.closest('[data-shipping-protection]'); if (!toggle || !protectionId) return; const card = toggle.closest('.shipping-protection'); card?.classList.add('is-loading'); toggle.disabled = true; const adding = toggle.checked; const url = adding ? root.dataset.addUrl : root.dataset.changeUrl; const body = adding ? { items: [{ id: protectionId, quantity: 1, properties: { _proteccion_envio: 'true' } }] } : { id: String(protectionId), quantity: 0 }; try { const response = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }); if (!response.ok) throw new Error('No se pudo actualizar la protección de envío'); await refresh() } catch (error) { toggle.checked = !adding; toggle.disabled = false; card?.classList.remove('is-loading'); console.error(error) } })
    document.addEventListener('submit', async event => { const form = event.target.closest('form[action*="/cart/add"]'); if (!form || event.submitter?.closest('.shopify-payment-button')) return; event.preventDefault(); const submitter = event.submitter; if (submitter) submitter.disabled = true; const response = await fetch(root.dataset.addUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) }); if (submitter) submitter.disabled = false; if (response.ok) open() })
    document.addEventListener('keydown', event => { if (event.key === 'Escape' && root.classList.contains('is-open')) close() })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-category-showcase"] && !Shopify.designMode) return;
  try {
    
  function initializeCategoryCollections(scope = document) {
    scope.querySelectorAll('[data-category-collections]').forEach(section => {
      if (section.dataset.initialized === 'true') return
      section.dataset.initialized = 'true'
      const tabs = [...section.querySelectorAll('[data-category-collection-tab]')]
      const panels = [...section.querySelectorAll('[data-category-collection-panel]')]
      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const target = tab.dataset.categoryCollectionTab
          tabs.forEach(item => {
            const active = item === tab
            item.classList.toggle('is-active', active)
            item.setAttribute('aria-selected', active ? 'true' : 'false')
          })
          panels.forEach(panel => {
            const active = panel.dataset.categoryCollectionPanel === target
            panel.classList.toggle('is-active', active)
            panel.hidden = !active
          })
        })
      })
    })
  }
  initializeCategoryCollections()
  document.addEventListener('shopify:section:load', event => initializeCategoryCollections(event.target))

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vettori-hero-slider')) {
    customElements.define('vettori-hero-slider', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.track = this.querySelector('.vettori-hero__track');
        this.slides = Array.from(this.querySelectorAll('.vettori-hero__slide'));
        this.dots = Array.from(this.querySelectorAll('.vettori-hero__dot'));
        this.index = 0;
        this.timer = null;
        this.startX = 0;
        this.moved = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.querySelector('.vettori-hero__arrow--previous')?.addEventListener('click', () => {
          this.show(this.index - 1);
          this.restart();
        });
        this.querySelector('.vettori-hero__arrow--next')?.addEventListener('click', () => {
          this.show(this.index + 1);
          this.restart();
        });
        this.dots.forEach((dot) => dot.addEventListener('click', () => {
          this.show(Number(dot.dataset.slide));
          this.restart();
        }));
        this.slides.forEach((slide) => {
          slide.addEventListener('click', (event) => {
            if (this.moved) {
              event.preventDefault();
              this.moved = false;
              return;
            }
            const href = slide.getAttribute('href');
            if (!href?.startsWith('#')) return;
            const sectionKey = slide.dataset.targetSection;
            const target = sectionKey ? document.querySelector('[id$="__' + sectionKey + '"]') : document.querySelector(href);
            if (!target) return;
            event.preventDefault();
            target.scrollIntoView({ behavior: this.reducedMotion ? 'auto' : 'smooth', block: 'start' });
            history.replaceState(null, '', href);
          });
        });
        this.addEventListener('pointerdown', (event) => {
          this.startX = event.clientX;
          this.moved = false;
          this.stop();
        });
        this.addEventListener('pointermove', (event) => {
          if (Math.abs(event.clientX - this.startX) > 12) this.moved = true;
        });
        this.addEventListener('pointerup', (event) => {
          const distance = event.clientX - this.startX;
          if (Math.abs(distance) > 50) this.show(this.index + (distance < 0 ? 1 : -1));
          this.start();
        });
        document.addEventListener('visibilitychange', () => document.hidden ? this.stop() : this.start());
        this.show(0);
        this.start();
      }

      disconnectedCallback() { this.stop(); }

      show(nextIndex) {
        const total = this.slides.length;
        this.index = (nextIndex + total) % total;
        this.track.style.transform = `translate3d(-${this.index * 100}%, 0, 0)`;
        this.slides.forEach((slide, index) => slide.setAttribute('aria-hidden', index === this.index ? 'false' : 'true'));
        this.dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === this.index);
          if (index === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      start() {
        if (this.dataset.autoplay !== 'true' || this.reducedMotion) return;
        this.stop();
        this.timer = window.setInterval(() => this.show(this.index + 1), Number(this.dataset.interval) || 5000);
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }

      restart() { this.stop(); this.start(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-orthopedic-showcase"] && !Shopify.designMode) return;
  try {
    
  function initCategoryShowcases(scope = document) {
    scope.querySelectorAll('[data-category-showcase]').forEach(showcase => {
      if (showcase.dataset.initialized === 'true') return
      showcase.dataset.initialized = 'true'
      const tabs = [...showcase.querySelectorAll('[data-category-tab]')]
      const panels = [...showcase.querySelectorAll('[data-category-panel]')]
      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const target = tab.dataset.categoryTab
          tabs.forEach(item => {
            const active = item === tab
            item.classList.toggle('is-active', active)
            item.setAttribute('aria-selected', active ? 'true' : 'false')
          })
          panels.forEach(panel => {
            const active = panel.dataset.categoryPanel === target
            panel.classList.toggle('is-active', active)
            panel.hidden = !active
          })
        })
      })
    })
  }
  initCategoryShowcases()
  document.addEventListener('shopify:section:load', event => initCategoryShowcases(event.target))

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-product-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.carouselInitialized === 'true') return;
      root.dataset.carouselInitialized = 'true';

      const tabs = Array.from(root.querySelectorAll('[data-collection-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-collection-panel]'));
      const viewAll = root.querySelector('[data-view-all]');
      const speed = Number(root.dataset.autoscrollSpeed || 30);
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let activeTrack = root.querySelector('[data-collection-panel]:not([hidden]) [data-product-track]');
      let frame;
      let previousTime;

      const prepareTrack = (track) => {
        if (!track || track.dataset.loopReady === 'true') return;
        const originals = Array.from(track.children);
        if (originals.length < 2) return;
        originals.forEach((card) => {
          const clone = card.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a, button, input, select, textarea').forEach((item) => item.setAttribute('tabindex', '-1'));
          track.appendChild(clone);
        });
        track.dataset.loopReady = 'true';
      };

      const switchTab = (selectedTab) => {
        const target = selectedTab.dataset.collectionTab;
        tabs.forEach((tab) => {
          const selected = tab === selectedTab;
          tab.classList.toggle('is-active', selected);
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.setAttribute('tabindex', selected ? '0' : '-1');
        });
        panels.forEach((panel) => {
          const selected = panel.dataset.collectionPanel === target;
          panel.hidden = !selected;
          panel.classList.toggle('is-active', selected);
        });
        if (viewAll && selectedTab.dataset.collectionUrl) viewAll.href = selectedTab.dataset.collectionUrl;
        activeTrack = root.querySelector(`[data-collection-panel="${target}"] [data-product-track]`);
        prepareTrack(activeTrack);
        if (activeTrack) activeTrack.scrollLeft = 0;
        previousTime = undefined;
      };

      tabs.forEach((tab, index) => {
        tab.setAttribute('tabindex', index === 0 ? '0' : '-1');
        tab.addEventListener('click', () => switchTab(tab));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const next = (tabs.indexOf(tab) + direction + tabs.length) % tabs.length;
          tabs[next].focus();
          switchTab(tabs[next]);
        });
      });

      panels.forEach((panel) => prepareTrack(panel.querySelector('[data-product-track]')));

      const animate = (time) => {
        if (!reduceMotion && activeTrack && !document.hidden) {
          if (previousTime !== undefined) {
            activeTrack.scrollLeft += speed * (time - previousTime) / 1000;
            const loopWidth = activeTrack.scrollWidth / 2;
            if (loopWidth > 0 && activeTrack.scrollLeft >= loopWidth) activeTrack.scrollLeft -= loopWidth;
          }
          previousTime = time;
        } else {
          previousTime = undefined;
        }
        frame = window.requestAnimationFrame(animate);
      };

      frame = window.requestAnimationFrame(animate);
      root.addEventListener('shopify:section:unload', () => window.cancelAnimationFrame(frame), { once: true });
    };

    document.querySelectorAll('[data-vettori-products]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-vettori-products]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  function initProductThumbControls(scope = document) {
    scope.querySelectorAll('.product-gallery').forEach(gallery => {
      if (gallery.dataset.thumbControlsReady === 'true') return
      gallery.dataset.thumbControlsReady = 'true'
      const track = gallery.querySelector('[data-product-thumb-track]')
      const previous = gallery.querySelector('[data-thumbs-previous]')
      const next = gallery.querySelector('[data-thumbs-next]')
      if (!track || !previous || !next) return

      const updateButtons = () => {
        previous.disabled = track.scrollLeft <= 1
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1
      }

      const scrollThumbs = direction => {
        const thumb = track.querySelector('.product-thumb')
        const distance = thumb ? (thumb.offsetWidth + 10) * 2 : track.clientWidth * .7
        track.scrollBy({ left: distance * direction, behavior: 'smooth' })
      }

      previous.addEventListener('click', () => scrollThumbs(-1))
      next.addEventListener('click', () => scrollThumbs(1))
      track.addEventListener('scroll', updateButtons, { passive: true })
      window.addEventListener('resize', updateButtons)
      updateButtons()
    })
  }

  initProductThumbControls()
  document.addEventListener('shopify:section:load', event => initProductThumbControls(event.target))

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-size-guide"] && !Shopify.designMode) return;
  try {
    
  function syncSizeGuideTriggers() {
    const controller = document.querySelector('[data-size-guide-controller]');
    const enabled = controller?.dataset.sizeGuideEnabled === 'true';
    document.querySelectorAll('[data-size-guide-open]').forEach((trigger) => {
      trigger.hidden = !enabled;
    });
  }

  if (!window.vettoriSizeGuideReady) {
    window.vettoriSizeGuideReady = true;
    document.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-size-guide-open]');
      if (openButton) {
        const dialog = document.querySelector('[data-size-guide-dialog]');
        if (dialog?.showModal) dialog.showModal();
        return;
      }

      const closeButton = event.target.closest('[data-size-guide-close]');
      if (closeButton) {
        closeButton.closest('[data-size-guide-dialog]')?.close();
        return;
      }

      if (event.target.matches('[data-size-guide-dialog]')) event.target.close();
    });
  }

  syncSizeGuideTriggers();
  document.addEventListener('shopify:section:load', syncSizeGuideTriggers);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-footer"]) return;
  try {
    
  const initializeVettoriFooters = () => {
    document.querySelectorAll('[data-vettori-footer]').forEach((footer) => {
      const disclosures = Array.from(footer.querySelectorAll('[data-footer-disclosure]'));
      const desktop = window.matchMedia('(min-width: 900px)');
      const sync = () => {
        disclosures.forEach((details) => {
          details.open = desktop.matches || details.dataset.mobileOpen === 'true';
        });
      };
      disclosures.forEach((details) => {
        details.addEventListener('toggle', () => {
          if (!desktop.matches && details.open) {
            disclosures.forEach((other) => {
              if (other !== details) other.open = false;
            });
          }
        });
      });
      sync();
      desktop.addEventListener('change', sync);
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeVettoriFooters, { once: true });
  } else {
    initializeVettoriFooters();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-header"]) return;
  try {
    
function initMobileMenuDrawers(scope=document){scope.querySelectorAll('[data-mobile-header]').forEach(component=>{if(component.dataset.mobileMenuReady==='true')return;component.dataset.mobileMenuReady='true';const openButton=component.querySelector('[data-mobile-menu-open]');const drawer=component.querySelector('[data-mobile-menu-drawer]');const closeButton=component.querySelector('[data-mobile-menu-close]');if(!openButton||!drawer||!closeButton)return;const closeDrawer=()=>{if(drawer.open)drawer.close()};openButton.addEventListener('click',()=>{drawer.showModal();openButton.setAttribute('aria-expanded','true');document.documentElement.classList.add('mobile-menu-open');closeButton.focus()});closeButton.addEventListener('click',closeDrawer);drawer.addEventListener('close',()=>{openButton.setAttribute('aria-expanded','false');document.documentElement.classList.remove('mobile-menu-open');openButton.focus()});drawer.addEventListener('click',event=>{const bounds=drawer.getBoundingClientRect();if(event.target===drawer&&event.clientX>bounds.right)closeDrawer()});drawer.querySelectorAll('a').forEach(link=>link.addEventListener('click',closeDrawer))})}initMobileMenuDrawers();document.addEventListener('shopify:section:load',event=>initMobileMenuDrawers(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vittori-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  function initVittoriAnnouncementBars(scope = document) {
    scope.querySelectorAll('[data-vittori-announcement]').forEach(bar => {
      if (bar.dataset.initialized === 'true') return
      bar.dataset.initialized = 'true'
      const items = [...bar.querySelectorAll('[data-vittori-item]')]
      if (items.length <= 1) return
      let currentIndex = 0
      const duration = Number.parseInt(bar.dataset.duration, 10) || 3000
      window.setInterval(() => {
        items[currentIndex].classList.remove('is-active')
        currentIndex = (currentIndex + 1) % items.length
        items[currentIndex].classList.add('is-active')
      }, duration)
    })
  }
  initVittoriAnnouncementBars()
  document.addEventListener('shopify:section:load', event => initVittoriAnnouncementBars(event.target))

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-popup"]) return;
  try {
    
  (() => {
    const popup = document.querySelector('[data-welcome-popup]')
    if (!popup || popup.dataset.initialized === 'true') return
    popup.dataset.initialized = 'true'
    const email = popup.querySelector('[data-popup-email]')
    const submit = popup.querySelector('[data-popup-submit]')
    const form = popup.querySelector('form')
    const error = popup.querySelector('[data-popup-error]')
    const duration = Number(popup.dataset.duration || 600)
    const delay = Number(popup.dataset.delay || 0) * 1000
    const repeat = Number(popup.dataset.repeatDays || 7) * 86400000
    const expiryKey = `vettori-popup-expiry-${popup.dataset.sectionId}`
    const dismissedKey = `vettori-popup-dismissed-${popup.dataset.sectionId}`
    const acceptedKey = `vettori-popup-accepted-${popup.dataset.sectionId}`
    let timer
    let remaining = duration
    const setDigits = value => {
      const minutes = String(Math.floor(value / 60)).padStart(2, '0')
      const seconds = String(value % 60).padStart(2, '0')
      popup.querySelector('[data-minute-tens]').textContent = minutes[0]
      popup.querySelector('[data-minute-ones]').textContent = minutes[1]
      popup.querySelector('[data-second-tens]').textContent = seconds[0]
      popup.querySelector('[data-second-ones]').textContent = seconds[1]
    }
    const updateButton = () => { submit.disabled = remaining <= 0 || !email.value.trim() || !email.validity.valid }
    const tick = () => {
      const expiry = Number(localStorage.getItem(expiryKey))
      remaining = Math.max(0, Math.ceil((expiry - Date.now()) / 1000))
      setDigits(remaining)
      updateButton()
      if (remaining <= 0) { clearInterval(timer); error.textContent = popup.dataset.expiredText; error.hidden = false }
    }
    const close = accepted => {
      clearInterval(timer)
      if (accepted) localStorage.setItem(acceptedKey, String(Date.now()))
      else localStorage.setItem(dismissedKey, String(Date.now()))
      popup.close()
      document.body.classList.remove('welcome-popup-open')
    }
    const open = () => {
      let expiry = Number(localStorage.getItem(expiryKey))
      if (!expiry || expiry <= Date.now()) { expiry = Date.now() + duration * 1000; localStorage.setItem(expiryKey, String(expiry)) }
      popup.showModal()
      document.body.classList.add('welcome-popup-open')
      tick()
      timer = setInterval(tick, 1000)
      setTimeout(() => email.focus(), 100)
    }
    const lastDismissed = Number(localStorage.getItem(dismissedKey) || 0)
    const accepted = localStorage.getItem(acceptedKey)
    if (window.Shopify?.designMode || (!accepted && Date.now() - lastDismissed > repeat)) setTimeout(open, delay)
    email.addEventListener('input', () => { error.hidden = true; updateButton() })
    popup.querySelectorAll('[data-popup-close]').forEach(button => button.addEventListener('click', () => close(false)))
    popup.addEventListener('cancel', event => { event.preventDefault(); close(false) })
    form.addEventListener('submit', async event => {
      event.preventDefault()
      if (!email.validity.valid || !email.value.trim() || remaining <= 0) { email.reportValidity(); return }
      submit.disabled = true
      submit.setAttribute('aria-busy', 'true')
      try {
        const response = await fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } })
        if (!response.ok) throw new Error('No se pudo registrar el correo')
        localStorage.setItem(acceptedKey, String(Date.now()))
        const codes = popup.dataset.discountCodes.split(',').map(code => code.trim()).filter(Boolean).join(',')
        const next = new URL(window.location.href)
        if (codes) next.searchParams.set('discount', codes)
        window.location.assign(next.toString())
      } catch (requestError) {
        error.hidden = false
        submit.removeAttribute('aria-busy')
        updateButton()
      }
    })
  })()

  } catch(e) { console.error(e); }
})();
})();
